import { render, staticRenderFns } from "./ConfigFields.vue?vue&type=template&id=36228183&scoped=true&"
import script from "./ConfigFields.vue?vue&type=script&lang=js&"
export * from "./ConfigFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36228183",
  null
  
)

export default component.exports